(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('par-curve-point', {
            parent: 'entity',
            url: '/par-curve-point',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'moldovaYieldCurvesApp.parCurvePoint.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/par-curve-point/par-curve-points.html',
                    controller: 'ParCurvePointController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('parCurvePoint');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('par-curve-point-detail', {
            parent: 'par-curve-point',
            url: '/par-curve-point/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'moldovaYieldCurvesApp.parCurvePoint.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/par-curve-point/par-curve-point-detail.html',
                    controller: 'ParCurvePointDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('parCurvePoint');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ParCurvePoint', function($stateParams, ParCurvePoint) {
                    return ParCurvePoint.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'par-curve-point',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('par-curve-point-detail.edit', {
            parent: 'par-curve-point-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/par-curve-point/par-curve-point-dialog.html',
                    controller: 'ParCurvePointDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ParCurvePoint', function(ParCurvePoint) {
                            return ParCurvePoint.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('par-curve-point.new', {
            parent: 'par-curve-point',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/par-curve-point/par-curve-point-dialog.html',
                    controller: 'ParCurvePointDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                date: null,
                                str: null,
                                deltaPeriods: null,
                                parRate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('par-curve-point', null, { reload: 'par-curve-point' });
                }, function() {
                    $state.go('par-curve-point');
                });
            }]
        })
        .state('par-curve-point.edit', {
            parent: 'par-curve-point',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/par-curve-point/par-curve-point-dialog.html',
                    controller: 'ParCurvePointDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ParCurvePoint', function(ParCurvePoint) {
                            return ParCurvePoint.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('par-curve-point', null, { reload: 'par-curve-point' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('par-curve-point.delete', {
            parent: 'par-curve-point',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/par-curve-point/par-curve-point-delete-dialog.html',
                    controller: 'ParCurvePointDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ParCurvePoint', function(ParCurvePoint) {
                            return ParCurvePoint.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('par-curve-point', null, { reload: 'par-curve-point' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
